'use client';

import { Phone } from 'lucide-react';
import { cn } from '@/core/utils/cn';

interface CallRegistryBadgeProps {
  count: number;
  className?: string;
}

export function CallRegistryBadge({ count, className }: CallRegistryBadgeProps) {
  if (count === 0) return null;

  return (
    <span
      id="calls_registry_badge"
      className={cn(
        'absolute -top-1 -right-1 flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-hms-red text-white text-[10px] font-bold',
        className
      )}
      aria-label={`${count} ringing call${count !== 1 ? 's' : ''}`}
    >
      {count}
    </span>
  );
}

export function CallRegistryIcon({
  count,
  className,
}: CallRegistryBadgeProps) {
  return (
    <div className={cn('relative', className)}>
      <Phone className="w-5 h-5 text-hms-textSub" />
      <CallRegistryBadge count={count} />
    </div>
  );
}
